
<div>
  <!--select layout type-->
  <div hidden="true" class="col-md-2 center">
    <mat-form-field>
      <mat-label>Layout</mat-label>
      <mat-select [(value)]="SelectedLayout" (selectionChange)="LayoutChange()">
        <mat-option [value]="'typical'">Typical</mat-option>
        <mat-option [value]="'wizard'">Wizard</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <button (click)="ResetSelections()"><fa-icon [icon]="faArrowRotateLeft"></fa-icon> Reset</button>
  </div>
</div>
<div [hidden]="SelectedLayout != 'typical'" class="col-md-12 row-no-margin flex-center">
  <!--typical layout-->
  <!--Make selections-->
  <div class="col-md-12 row-no-margin flex-center" [hidden]="ShowTypicalResults">
    <div class="col-md-2">
      <div class="col-md-10">
        <mat-form-field>
          <mat-label>Actuator</mat-label>
          <mat-select [(value)]="Actuator_SelectedActuator" (selectionChange)="ActuatorSelected('actuator')">
            @for(act of Actuator_Actuators;track act){
            <mat-option [value]="act">{{act.Name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-10">
        <mat-form-field>
          <mat-label>Motor</mat-label>
          <mat-select [(value)]="Actuator_SelectedMotor" (selectionChange)="MotorSelected()">
            @for(mot of Actuator_Motors; track mot){
            <mat-option [value]="mot">{{mot.Name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class=" col-md-10">
        <mat-form-field>
          <mat-label>Feedback Code</mat-label>
          <mat-select [(value)]="Actuator_SelectedFeedback" (selectionChange)="FeedbackSelected()">
            @for(feed of Actuator_AvailableFeedbackCodes;track feed){
            <mat-option [value]="feed">{{feed.Code + " - " + feed.Manufacturer.Name + ", " + feed.FeedbackTypeObject.Type}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class=" col-md-10" style="padding-bottom:22px;">
        <mat-checkbox [checked]="Actuator_BrakeSelected" (change)="Actuator_BrakeSelected = !Actuator_BrakeSelected">Brake?</mat-checkbox>
      </div>
      <div class="col-md-10">
        <mat-form-field>
          <mat-label>Drive Manufacturer</mat-label>
          <mat-select [(value)]="Actuator_SelectedMFG" [disabled]="!MFGEnabled" (selectionChange)="MFGSelected('actuator')">
            @for(mfg of Actuator_AvailMFGS;track mfg){
            <mat-option [value]="mfg">{{mfg.DisplayName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class=" col-md-10">
        <mat-form-field>
          <mat-label>Drive Series</mat-label>
          <mat-select [(value)]="Actuator_SelectedDriveSeries" (selectionChange)="SeriesSelected()">
            @for(ser of Actuator_Drives;track ser){
            <mat-option [value]="ser">{{ser.Series}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-2">
      <div class=" col-md-10">
        <mat-form-field>
          <mat-label>Drive Manufacturer</mat-label>
          <mat-select [(value)]="Drive_SelectedMFG" [disabled]="!MFGEnabled" (selectionChange)="MFGSelected('drive')">
            @for(mfg of Drive_AvailMFGS;track mfg){
            <mat-option [value]="mfg">{{mfg.DisplayName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class=" col-md-10">
        <mat-form-field>
          <mat-label>Drive Series</mat-label>
          <mat-select [(value)]="Drive_SelectedDriveSeries" (selectionChange)="SeriesSelected()">
            @for(ser of Drive_Drives;track ser){
            <mat-option [value]="ser">{{ser.Series}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class=" col-md-10">
        <mat-form-field>
          <mat-label>Actuator</mat-label>
          <mat-select [(value)]="Drive_SelectedActuator" (selectionChange)="ActuatorSelected('drive')">
            @for(act of Drive_Actuators;track act){
            <mat-option [value]="act">{{act.Name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class=" col-md-10">
        <mat-form-field>
          <mat-label>Motor</mat-label>
          <mat-select [(value)]="Drive_SelectedMotor" (selectionChange)="MotorSelected()">
            @for(mot of Drive_Motors; track mot){
            <mat-option [value]="mot">{{mot.Name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class=" col-md-10" style="padding-bottom:22px;">
        <mat-checkbox [checked]="Drive_BrakeSelected" (change)="Drive_BrakeSelected = !Drive_BrakeSelected">Brake?</mat-checkbox>
      </div>
      <div class=" col-md-10">
        <mat-form-field>
          <mat-label>Feedback Code</mat-label>
          <mat-select [(value)]="Drive_SelectedFeedback" (selectionChange)="FeedbackSelected()">
            @for(feed of Drive_AvailableFeedbackCodes;track feed){
            <mat-option [value]="feed">{{feed.Code + " - " + feed.Manufacturer.Name + ", " + feed.FeedbackTypeObject.Type}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <!--Results-->
  <div class="col-md-12 row-no-margin flex-center" [hidden]="!ShowTypicalResults">
    <!--<app-results style="width:100%;" [Actuator]="SelectedActuator"
                 [Motor]="SelectedMotor"
                 [Feedback]="SelectedFeedback"
                 [Manufacturer]="SelectedMFG"
                 [Drive]="SelectedDriveSeries"
                 [Connectors]="SelectedConnectors"
                 [BrakeSelected]="BrakeSelected"
                 [Cables]="SelectedCables"
                 [PowerCableImage]="PowerCableImage"
                 [FeedbackCableImage]="FeedbackCableImage"
                 [HybridCableImage]="HybridCableImage"
                 [FeedbackDevice]="SelectedFeedbackDevice"></app-results>-->
  </div>
</div>
<div [hidden]="SelectedLayout != 'wizard'" class="col-md-12">
  <!--Wizard layout-->
  <mat-stepper linear #stepper>
    <mat-step [stepControl]="firstFormGroup" editable="true" completed="false">
      <form [formGroup]="firstFormGroup">
        <ng-template matStepLabel>Start</ng-template>
        <div class="col-md-12 p-5">
          <div class="col-md-3 center">
            Choose your starting point
          </div>
          <div class="row-no-margin col-md-12 center">
            <!--Drive-->
            <div class="button-wrapper center round-borders hover-highlight clickable" [ngClass]="{'selected-highlight' : StartPoint == 'drive'}" (click)="SelectStartPoint('drive')">
              <div class="center  stepper-tile">
                <div class="tile-text">
                  <span>Servo Drive</span>
                </div>
                <img alt="drive" src="./assets/images/drive.png" />
              </div>
            </div>
            <!--Actuator-->
            <div class="button-wrapper center round-borders hover-highlight clickable " [ngClass]="{'selected-highlight' : StartPoint == 'actuator'}" (click)="SelectStartPoint('actuator')">
              <div class="center stepper-tile">
                <div class="tile-text">
                  <span>Servo Actuator</span>
                </div>
                <img alt="actuator" src="./assets/images/actuator.png" />
              </div>
            </div>
          </div>
        </div>
        <div>
          <button mat-button [disabled]="StartPoint == ''" (click)="NextStep()" type="button">Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup" editable="true" completed="false">
      <form [formGroup]="secondFormGroup">
        <ng-template matStepLabel>
          @if(StartPoint == 'actuator'){
          <img alt="actuator" src="./assets/images/actuator.png" />
          }
          @else if(StartPoint == 'drive'){
          <img src="./assets/images/drive.png" />
          }
        </ng-template>
        <div class="col-md-12 row-no-margin pt-5 pb-5">
          <div class="leftPane"></div>
          <div class="col-md-6 center" [hidden]="StartPoint != 'actuator'">
            <div class="col-md-6 center">
              <mat-form-field>
                <mat-label>Servo Actuator</mat-label>
                <mat-select [(value)]="Actuator_SelectedActuator" (selectionChange)="ActuatorSelected('actuator')">
                  @for(act of Actuator_Actuators;track act){
                  <mat-option [value]="act">{{act.Name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6 center">
              <div class="row-no-margin tooltipCont">
                <mat-form-field style="width:90%;">
                  <mat-label>Motor</mat-label>
                  <mat-select [(value)]="Actuator_SelectedMotor" (selectionChange)="MotorSelected()">
                    @for(mot of Actuator_Motors; track mot){
                    <mat-option [value]="mot">{{mot.Name}}-{{mot.BusVoltage + "Vac"}}/{{mot.MagnetStacks}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div class="TOL_tooltip">
                  <fa-icon [icon]="faCircleInfo" style="padding: 10px; color: #335b7a;" (click)="Tooltip_Click('Actuator_MotorTooltip')">
                  </fa-icon>
                  <div [hidden]="!Actuator_MotorTooltip" class="tooltiptext" (click)="Tooltip_Click('Actuator_MotorTooltip')">
                    <span>
                      The nominal motor voltage is described as either MV2x or MV4x:
                      <br />
                      2 = 230Vac
                      <br />
                      4 = 460Vac
                      <br /><br />
                      Stack length relates to the torque and thermal capacity of the motor and is described as either MVx1 or MVx3. Refer to our <a target="_blank" href="https://sizeit.tolomatic.com">Sizing Software</a> to determine the appropriate stack length for your application.
                      <br />1=Lowest Torque
                      <br />3=Highest Torque
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 center">
              <div class="row-no-margin tooltipCont">
                <mat-form-field style="width:90%;">
                  <mat-label>Feedback Code</mat-label>
                  <mat-select [(value)]="Actuator_SelectedFeedback" (selectionChange)="FeedbackSelected()">
                    @for(mfg of getFBCodeMFGs(Actuator_AvailableFeedbackCodes); track mfg){
                    <mat-optgroup [label]="mfg.DisplayName">
                      @for(feed of getFBCodeFromMFG(mfg);track feed){
                      <mat-option [value]="feed">{{feed.Code + " - " + feed.Manufacturer.DisplayName + ", " + feed.FeedbackTypeObject.Type}}</mat-option>
                      }
                    </mat-optgroup>
                    }
                  </mat-select>
                </mat-form-field>
                <div class="TOL_tooltip">
                  <fa-icon [icon]="faCircleInfo" style="padding: 10px; color: #335b7a;" (click)="Tooltip_Click('Actuator_FeedbackTooltip')"></fa-icon>
                  <div [hidden]="!Actuator_FeedbackTooltip" class="tooltiptext" (click)="Tooltip_Click('Actuator_FeedbackTooltip')">
                    <span>
                      Feedback Code
                      <br />
                      The first character of the feedback code denotes the connection type:
                      <br />
                      D = Circular Connectors
                      <br />
                      C = Integrated Cable with Connector
                      <br />
                      F = Integrated Cable with Flying Leads                      
                      <br />
                      <br />
                      The next two characters denote the motor manufactures' connectors and pinout for a given motor series:
                      <br />
                      A1 = Rockwell MP
                      <br />
                      A2 = Rockwell VP
                      <br />
                      B1 = Bosch Rexroth MSK
                      <br />
                      E1 = Control Techniques / Nidec FM/HD
                      <br />
                      L1 = Lenze MCS
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 center">
              <div class="row-no-margin pb-4">
                <!--<mat-checkbox [checked]="Actuator_BrakeSelected" (change)="Actuator_BrakeSelected = !Actuator_BrakeSelected">Brake?</mat-checkbox>-->
                <!--<mat-slide-toggle [checked]="Actuator_BrakeSelected" (change)="Actuator_BrakeSelected = !Actuator_BrakeSelected">Brake?</mat-slide-toggle>-->
                <app-toggle [initial]="Actuator_BrakeSelected" idForControl="Actuator_BrakeSelected" trueText="" falseText="" labelText="Brake?" (changed)="Actuator_BrakeSelected = !Actuator_BrakeSelected"></app-toggle>

              </div>
            </div>
          </div>
          <div class="col-md-6 center" [hidden]="StartPoint != 'drive'">
            <div class="col-md-6 center">
              <mat-form-field>
                <mat-label>Drive Manufacturer</mat-label>
                <mat-select [(value)]="Drive_SelectedMFG" [disabled]="!MFGEnabled" (selectionChange)="MFGSelected('drive')">
                  @for(mfg of Drive_AvailMFGS;track mfg){
                  <mat-option [value]="mfg">{{mfg.DisplayName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6 center">
              <mat-form-field>
                <mat-label>Drive Series</mat-label>
                <mat-select [(value)]="Drive_SelectedDriveSeries" (selectionChange)="SeriesSelected()">
                  @for(ser of Drive_Drives;track ser){
                  <mat-option [value]="ser">{{ser.Series}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="rightPane"></div>
        </div>
        <div>
          <button mat-button (click)="PreviousStep()" type="button">Previous</button>
          &nbsp;
          <button mat-button (click)="NextStep()" [disabled]="Actuator_SelectedFeedback.Code == '' && Drive_SelectedDriveSeries.Series == ''" type="button">Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="thirdFormGroup" editable="true" completed="false">
      <form [formGroup]="thirdFormGroup">
        <ng-template matStepLabel>
          @if(StartPoint == 'drive'){
          <img alt="actuator" src="./assets/images/actuator.png" />
          }
          @else if(StartPoint == 'actuator'){
          <img src="./assets/images/drive.png" />
          }
        </ng-template>
        <div class="col-md-12 p-5">
          <div class="leftPane"></div>
          <div class="col-md-6 center" [hidden]="StartPoint != 'drive'">
            <div class="col-md-6 center">
              <mat-form-field>
                <mat-label>Servo Actuator</mat-label>
                <mat-select [(value)]="Drive_SelectedActuator" (selectionChange)="ActuatorSelected('drive')">
                  @for(act of Drive_Actuators;track act){
                  <mat-option [value]="act">{{act.Name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6 center">
              <div class="tooltipCont">
                <mat-form-field style="width:90%;">
                  <mat-label>Motor</mat-label>
                  <mat-select [(value)]="Drive_SelectedMotor" (selectionChange)="MotorSelected()">
                    @for(mot of Drive_Motors; track mot){
                    <mat-option [value]="mot">{{mot.Name}}-{{mot.BusVoltage + "V"}}/{{mot.MagnetStacks}}</mat-option>
                    }
                  </mat-select>

                </mat-form-field>
                <div class="TOL_tooltip">
                  <fa-icon [icon]="faCircleInfo" style="padding: 10px; color: #335b7a;" (click)="Tooltip_Click('Drive_MotorTooltip')"></fa-icon>
                  <div [hidden]="!Drive_MotorTooltip" class="tooltiptext" (click)="Tooltip_Click('Drive_MotorTooltip')">
                    <span>
                      The nominal motor voltage is described as either MV2x or MV4x:
                      <br />
                      2 = 230Vac
                      <br />
                      4 = 460Vac
                      <br /><br />
                      Stack length relates to the torque and thermal capacity of the motor and is described as either MVx1 or MVx3. Refer to our <a target="_blank" href="https://sizeit.tolomatic.com">Sizing Software</a> to determine the appropriate stack length for your application.
                      <br />1=Lowest Torque
                      <br />3=Highest Torque
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 center">
              <div class="tooltipCont">
                <mat-form-field style="width:90%;">
                  <mat-label>Feedback Code</mat-label>
                  <mat-select [(value)]="Drive_SelectedFeedback" (selectionChange)="FeedbackSelected()">
                    @for(feed of Drive_AvailableFeedbackCodes;track feed){
                    <mat-option [value]="feed">{{feed.Code + " - " + feed.Manufacturer.Name + ", " + feed.FeedbackTypeObject.Type}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div class="TOL_tooltip">
                  <fa-icon [icon]="faCircleInfo" style="padding: 10px; color: #335b7a;" (click)="Tooltip_Click('Drive_FeedbackTooltip')"></fa-icon>
                  <div [hidden]="!Drive_FeedbackTooltip" class="tooltiptext" (click)="Tooltip_Click('Drive_FeedbackTooltip')">
                    <span>
                      Feedback Code
                      <br />
                      The first character of the feedback code denotes the connection type:
                      <br />
                      D = Circular Connectors
                      <br />
                      C = Integrated Cable with Connector
                      <br />
                      F = Integrated Cable with Flying Leads
                      <br/>
                      <br />
                      The next two characters denote the motor manufactures' connectors and pinout for a given motor series:
                      <br />
                      A1 = Rockwell MP
                      <br />
                      A2 = Rockwell VP
                      <br />
                      B1 = Bosch Rexroth MSK
                      <br />
                      E1 = Control Techniques / Nidec FM/HD
                      <br />
                      L1 = Lenze MCS
                    </span>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-6 center pb-4">

              <!--<mat-checkbox [checked]="Drive_BrakeSelected" (change)="Drive_BrakeSelected = !Drive_BrakeSelected">Brake?</mat-checkbox>-->
              <!--<mat-slide-toggle [checked]="Drive_BrakeSelected" (change)="Drive_BrakeSelected = !Drive_BrakeSelected">Brake?</mat-slide-toggle>-->
              <div class="row-no-margin">
                <app-toggle [initial]="Drive_BrakeSelected" idForControl="Drive_BrakeSelected" trueText="" falseText="" labelText="Brake?" (changed)="Drive_BrakeSelected = !Drive_BrakeSelected"></app-toggle>


              </div>
            </div>
          </div>
          <div class="col-md-6 center" [hidden]="StartPoint != 'actuator'">
            <div class="col-md-6 center">
              <mat-form-field>
                <mat-label>Manufacturer</mat-label>
                <mat-select [(value)]="Actuator_SelectedMFG" [disabled]="!MFGEnabled" (selectionChange)="MFGSelected('actuator')">
                  @for(mfg of Actuator_AvailMFGS;track mfg){
                  <mat-option [value]="mfg">{{mfg.DisplayName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6 center">
              <mat-form-field>
                <mat-label>Drive Series</mat-label>
                <mat-select [(value)]="Actuator_SelectedDriveSeries" (selectionChange)="SeriesSelected()">
                  @for(ser of Actuator_Drives;track ser){
                  <mat-option [value]="ser">{{ser.Series}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="rightPane">
           
          </div>
        </div>
        <div>
          <button mat-button (click)="PreviousStep()" type="button">Previous</button>
          &nbsp;
          <button mat-button (click)="NextStep()" type="button">Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="fourthFormGroup" editable="true" completed="false">
      <form [formGroup]="fourthFormGroup">
        <ng-template matStepLabel>Results</ng-template>
        <app-results style="width:100%;" [Actuator]="SelectedActuator"
                     [Motor]="SelectedMotor"
                     [Feedback]="SelectedFeedback"
                     [Manufacturer]="SelectedMFG"
                     [TolomaticMFG]="TolomaticMFG"
                     [Drive]="SelectedDriveSeries"
                     [Connectors]="SelectedConnectors"
                     [BrakeSelected]="BrakeSelected"
                     [Cables]="SelectedCables"
                     [PowerCableImage]="PowerCableImage"
                     [FeedbackCableImage]="FeedbackCableImage"
                     [HybridCableImage]="HybridCableImage"
                     [FeedbackDevice]="SelectedFeedbackDevice"
                     [HideSuggestedCables]="HideSuggestedCables"></app-results>
        <button mat-button (click)="PreviousStep()" type="button">Previous</button>
      </form>
    </mat-step>
  </mat-stepper>

</div>
